'use strict';

import {BaseElement} from "../../../../interfaces/BaseElement";
import {components, isMobile, isNoMenu, settingsData, UIRoot} from '../../../../../settings';
import {PopUpPage} from "../../../../interfaces/pages/PopUp";
import {Price} from "../../../../cards/Price";
import {facingDictionary} from "../../../../cards/cardsConfig";
import {changeLangToCurrent} from "../../../../components/langSwitcher/langSwitcher";
import {clamp, getFieldsFromAPI, getMoneyToken} from "../../../../../functions";
import {
    createCheckbox,
    createOptionTitleText,
    getUniqueUnits,
    searchGetResults, selectedBuildings,
} from '../../search';
import { EventBus } from '../../../../interfaces/EventBus';
import {createMultipleSearch, updateMultiSearch, updateMultiSearchState} from "../../multipleSearch";
import {MultipleSelector} from "../../../../interfaces/MultipleSelector";

export class Filter {
    #rootElement;
    #filterPopUpPage;
    #filterPopUpContent;
    #applyFilters;
    #applyBtn;
    #isReset = false;
    #selectedSearchState = '';

    constructor(applyFilters) {
        this.#applyFilters = applyFilters;
        this.#rootElement = new BaseElement()
            .event('click', this.#showFilterPopUp.bind(this))
            .addClass('mobile-search__filter');

        this.#button();
        this.#filterPopUp();

        EventBus.add('filterShowFilterPopUp', this.#showFilterPopUp.bind(this));
    }

    get rootElement() {
        return this.#rootElement;
    }

    remove() {
        EventBus.remove('updateApplyBtnCount');
        EventBus.remove('filterShowFilterPopUp');

        this.#filterPopUpContent.remove();
        this.#filterPopUpContent = null;
        this.#filterPopUpPage.root.remove();
        this.#filterPopUpPage = null;
        this.#rootElement.remove();
        this.#rootElement = null;
    }

    #button() {
        new BaseElement('button')
            .addClass('mobile-search__filter-button', 'icon-search')
            .appendTo(this.#rootElement);
        new BaseElement('span')
            .addClass('mobile-search__filter-text', 'language-string')
            .setAttributes({'data-dictionary': 'findProperty'})
            .innerHtml(changeLangToCurrent('findProperty'))
            .appendTo(this.#rootElement);
    }

    #filterPopUp() {
        this.#filterPopUpPage = new PopUpPage('filter options');
        this.#filterPopUpPage.addClass('filter-pop-up');
        if (isNoMenu)
            this.#filterPopUpPage.addClass('no-menu-mode');
        this.#filterPopUpPage.addClass('hidden');

        this.#filterPopUpContent = new BaseElement()
            .addClass('mobile-search__filter-pop-up')
            .appendTo(this.#filterPopUpPage.contentElement);

        const filterButtons = new BaseElement()
            .addClass('mobile-search__filter-buttons')
            .appendTo(this.#filterPopUpPage.contentElement)
            .DOMElement;

        this.#addFilters(this.#filterPopUpContent.DOMElement);
        createMultipleSearch();

        new BaseElement('button')
            .addClass('mobile-search__clear-filter', 'language-string')
            .addAttribute('data-dictionary', 'Clear all')
            .innerHtml(changeLangToCurrent('Clear all'))
            .event('click',this.#clearFilter.bind(this))
            .appendTo(filterButtons);

        this.#applyBtn = new BaseElement('button')
            .addClass('mobile-search__apply-filter', 'language-string')
            .event('click', this.#applyFiltersHandler.bind(this))
            .appendTo(filterButtons);


        const popUpHeaderElement = this.#filterPopUpPage.root.querySelector('.pop-up-page__header');
        // let startX = 0;
        let startY = 0;
        // let endX = 0;
        // let endY = 0;

        popUpHeaderElement.addEventListener('touchstart', (e) => {
            // startX = e.touches[0].clientX;
            startY = e.touches[0].clientY;
        });

        popUpHeaderElement.addEventListener('touchend', (e) => {
            const endY = e.changedTouches[0].clientY;
            const diffY = endY - startY;
            if (diffY > 30) {
                this.#hideFilterPopUp();
                components.mobileSearch.setStateTo('focused');
            }
        });

        this.#filterPopUpPage.root.querySelector('.pop-up-page__header').addEventListener('click', () => {
            this.#hideFilterPopUp();
            if (UIRoot.querySelector('.mobile-search__bottom-element').getAttribute('data-state') !== 'opened-fully')
                components.mobileSearch.setStateTo('focused');
        });

        EventBus.add('updateApplyBtnCount',this.#updateBtnCountHandler.bind(this));
        EventBus.trigger('updateApplyBtnCount', searchGetResults(0,null,false).length);
    }

    #clearFilter(resetChips = true, applyFilter = true, resetToPreviouslyResult = false) {
        this.#isReset = true;
        const selectedSearchState = JSON.parse(this.#selectedSearchState);

        const allCheckboxes = [...this.#filterPopUpContent.DOMElement.querySelectorAll('.search__option-input[type="checkbox"]')];
        allCheckboxes.forEach(checkbox => {
            if (resetToPreviouslyResult) {
                const data = selectedSearchState.find(el => el.type === checkbox.getAttribute('data-type'));
                if (data) {
                    const checked = data.checked.value;
                    const checkboxValue = Number(checkbox.getAttribute('data-roomnum'));
                    if (!checked.includes(checkboxValue) && checkbox.checked) {
                        checkbox.click();
                    }
                } else if (checkbox.checked) {
                    checkbox.click()
                }
            } else if (checkbox.checked) {
                checkbox.click()
            }
        });

        const allSwitches = [...this.#filterPopUpContent.DOMElement.querySelectorAll('.switch__checkbox')];
        allSwitches.forEach(switchElement => {
           if (switchElement.checked)
               switchElement.click();
        });

        const allSelects = [...this.#filterPopUpContent.DOMElement.querySelectorAll('.search__option select')];
        allSelects.forEach(select => {
            if (resetToPreviouslyResult) {
                const data = selectedSearchState.find(el => el.type === select.getAttribute('data-type'));
                if (data && data.min.length && data.max.length) {
                    if (select.getAttribute('select-type') === 'min') {
                        select.selectedIndex = [...select.options].findIndex(el => el.value === data.min);
                    } else if (select.getAttribute('select-type') === 'max') {
                        select.selectedIndex = [...select.options].findIndex(el => el.value === data.max);
                    }
                } else {
                    if (select.getAttribute('select-type') === 'min') {
                        select.selectedIndex = 0;
                    } else if (select.getAttribute('select-type') === 'max') {
                        select.selectedIndex = select.options.length - 1;
                    }
                }
            } else {
                if (select.getAttribute('select-type') === 'min') {
                    select.selectedIndex = 0;
                } else if (select.getAttribute('select-type') === 'max') {
                    select.selectedIndex = select.options.length - 1;
                }
            }

            select.dispatchEvent(new Event('change'));
        });

        const allMultiBuildingsButtons = [...this.#filterPopUpContent.DOMElement.querySelectorAll('.active-multi-building')];
        allMultiBuildingsButtons.forEach(item => {
            item.classList.remove('active-multi-building');
        });
        MultipleSelector.uncheckAll('modelName');
        MultipleSelector.uncheckAll('multipleSearch');
        updateMultiSearch();
        updateMultiSearchState();

        selectedBuildings.clear();

        EventBus.trigger('updateApplyBtnCount', searchGetResults(0,null,false).length);

        applyFilter && this.#applyFilters();
    }

    #updateBtnCountHandler(count) {
        if (count > 0 && Filter.filterIsChanged()) {
            this.#applyBtn.DOMElement.disabled = false;
            this.#applyBtn.removeClass('mobile-search__apply-filter--disabled');
            this.#applyBtn.innerHtml(changeLangToCurrent('apartment found mobile') + ' (' + count + ')');
        } else if (count === 0 && Filter.filterIsChanged()) {
            this.#applyBtn.DOMElement.disabled = true;
            this.#applyBtn.addClass('mobile-search__apply-filter--disabled');
            this.#applyBtn.innerHtml(changeLangToCurrent('No results found'));
        } else {
            this.#applyBtn.DOMElement.disabled = false;
            this.#applyBtn.removeClass('mobile-search__apply-filter--disabled');
            this.#applyBtn.innerHtml(changeLangToCurrent('apartment found mobile') + ' (' + count + ')');
        }
    }

    #addFilters(mainContainer) {
        // const searchSortState = getFieldsFromAPI.filter();
        const displayPrice = new Price().showPrice;
        let states = getFieldsFromAPI.filter().slice();

        if (!displayPrice)
            states = states.filter(el => el.type !== 'salePrice').filter(el => el.type !== 'rentPrice');

        settingsData.searchState = [];
        for (const field of this.#filters()) {
            const hidePrice = (
                field.key === 'salePrice' ||
                field.key === 'rentPrice' ||
                field.key === 'maintenanceFee' ||
                field.key === 'managementFee'
            ) && (!displayPrice);

            let inputCondition = getUniqueUnits(settingsData.allCrmData, field);

            if (hidePrice || inputCondition.length === 1)
                continue;

            if (inputCondition.length === 0 || hidePrice) {
                const item = states.find(state => state.type === field.key);
                const index = states.indexOf(item);

                index !== -1 && states.splice(index, 1);
                continue;
            }

            if (field.key === 'facing')
                inputCondition = inputCondition.reduce((arr, item) => {
                    item.forEach(str => {
                        const strMod = /^[A-Za-z]*$/.test(str) ? str : facingDictionary()[str].en;

                        if (arr.indexOf(strMod) === -1)
                            arr.push(strMod);
                    });

                    return arr;
                }, []);

            const elementContainer = new BaseElement()
                .addClass('search__option')
                .addAttribute('data-type', field.key)
                .appendTo(mainContainer);
            const elementTitle = new BaseElement('h2')
                .addClass('search__option-title')
                .appendTo(elementContainer.DOMElement);

            new BaseElement('span')
                .addClass(field.icon, 'search__option-title--icon')
                .appendTo(elementTitle.DOMElement);

            createOptionTitleText(elementTitle.DOMElement, field.labelKey);

            if (field.key === 'salePrice' || field.key === 'rentPrice') {
                new BaseElement('span')
                    .appendTo(elementTitle.DOMElement)
                getMoneyToken().appendTo(elementTitle.DOMElement);
            }

            if (field.key === 'modelName') {
                if (inputCondition.length > 5) {
                    const select = new BaseElement('select')
                        .addAttribute('multiple', 'multiple')
                        .addClass('multiple__select', 'multiple-select')
                        .appendTo(elementContainer.DOMElement)
                        .DOMElement;

                    inputCondition.forEach(condition => {
                        new BaseElement('option')
                            .addAttribute(`data-${field.key}`, `${condition}`)
                            .addAttribute(`data-type`, `${field.key}`)
                            .addAttribute('value',condition)
                            .innerHtml(condition)
                            .appendTo(select);
                    });

                    if (!settingsData.searchState.find(item => item.type === field.key)) {
                        settingsData.searchState.push({
                            type: field.key,
                            checked: {
                                state: [...inputCondition],
                                value: [],
                            },
                        });
                    }

                    const multipleSelector = new MultipleSelector(select, 'modelName', {
                        showClear: true,
                        selectAll: false,
                        animate: 'fade',
                        minimumCountSelected: 100000,
                    });

                    multipleSelector.minSelected = isMobile ? 2 : 3;

                    multipleSelector.addCallback('onClick', (scope, view) => {
                        const state = settingsData.searchState.find(state => state.type === field.key);
                        if (view.selected) {
                            state.checked.value.push(view.value);
                        } else {
                            state.checked.value = state.checked.value.filter(v => v !== view.value);
                        }
                        searchGetResults();
                    });

                    multipleSelector.addCallback('onUncheckAll', (scope) => {
                        const state = settingsData.searchState.find(state => state.type === field.key);
                        state.checked.value = [];
                        searchGetResults();
                    });

                    multipleSelector.addCallback('onUpdatePlaceholder', (placeholder, selected) => {
                        const selectedItems = selected.size;
                        if (selectedItems === 0) {
                            placeholder.text(changeLangToCurrent('modelTypePlaceholder'));
                        } else {
                            const data = [...selected].map(el => el.modelname).slice(clamp(selectedItems - multipleSelector.minSelected,0,selectedItems), selectedItems);
                            if (data.length > 1) {
                                placeholder.text(data.join(' | ').toString());
                            } else {
                                placeholder.text(data.join('').toString());
                            }
                        }
                    });
                } else {
                    createCheckbox(inputCondition, elementContainer.DOMElement, field);
                }
            } else {
                createCheckbox(inputCondition, elementContainer.DOMElement, field);
            }
        }

        this.#selectedSearchState = JSON.stringify(settingsData.searchState);
    }

    #applyFiltersHandler() {
        this.#isReset = false;
        this.#selectedSearchState = JSON.stringify(settingsData.searchState);
        this.#applyFilters();
        EventBus.trigger('searchChipsSyncWithFilter', this.#filterPopUpContent.DOMElement);
        components.mobileSearch.setStateTo('focused');
        this.#hideFilterPopUp();
    }

    #showFilterPopUp() {
        this.#filterPopUpPage.removeClass('hidden');
        PopUpPage.animation('show');
    }

    #hideFilterPopUp() {
        PopUpPage.animation('hide');
    }

    #filters() {
        const fields = getFieldsFromAPI.filter();
        return fields.map(field => {
            if (field.key === 'roomNum') {
                field.order = 0;
            } else if (field.key === 'salePrice') {
                field.order = 1;
            } else if (field.key === 'floorNum') {
                field.order = 2;
            } else {
                field.order += 10;
            }

            return field;
        }).sort((a, b) => a.order - b.order);
    }

    static filterIsChanged() {
        const state = settingsData.searchState;
        let changedFilter = false;

        state.forEach(el => {
            if (el.hasOwnProperty('checked') && el.checked.value.length > 0) {
                changedFilter = true;
            } else if (el.hasOwnProperty('min') && el.hasOwnProperty('max')) {
                const min = Number(el.min);
                const max = Number(el.max);
                if (min !== el.startMin) {
                    changedFilter = true;
                }
                if (max !== el.startMax) {
                    changedFilter = true;
                }
            }
        });

        return changedFilter;
    }
}
